import { ConfigProvider } from 'antd';
import fa from 'antd/es/locale/fa_IR';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'query/QueryClient';
import { BrowserRouter as RouterTemp } from 'react-router-dom';
import { store } from 'redux/store';

const Router = RouterTemp as any;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={fa}
        direction='rtl'
        theme={{
          token: {
            fontFamily: 'iranyekan',
            colorPrimary: '#007141',
            colorError: '#ff0000',
            colorSuccess: '#00ff00',
            colorWarning: '#ffaa00',
          },
        }}>
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
